var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 pt-6" },
        [
          _c(
            "v-col",
            { staticClass: "pl-0", attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("img", {
                        staticClass: "arrow px-4 py-3",
                        attrs: { src: _vm.ic_back, id: "back-btn" },
                        on: { click: _vm.backToPrevPage },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-n4", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "back-lbl" }, [
                        _vm._v(_vm._s(_vm.backToLbl) + " "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "px-16 mb-12 mt-n10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v(_vm._s(_vm.pageHeader)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-n5" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "page-sub-header" }, [
                        _vm._v(
                          "Update the equipment list for future bookings."
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      class: {
                        "pr-2": _vm.sm,
                        "pr-3": _vm.xs,
                      },
                      attrs: { cols: "12", xl: "5", lg: "5", md: "5", sm: "7" },
                    },
                    [
                      _c("smart-text-field", {
                        staticClass: "employees-search",
                        attrs: {
                          placeholder: "Search",
                          search: true,
                          clearable: true,
                          "css-class": { "mt-2": _vm.mdAndUp },
                          "background-color": "white",
                        },
                        on: {
                          clear: _vm.onClear,
                          input: function ($event) {
                            return _vm.applyFilters()
                          },
                          "enter-pressed": function ($event) {
                            return _vm.applyFilters()
                          },
                        },
                        model: {
                          value: _vm.term,
                          callback: function ($$v) {
                            _vm.term = $$v
                          },
                          expression: "term",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    {
                      class: { "pl-0": _vm.smAndDown },
                      attrs: { cols: "auto" },
                    },
                    [
                      _c("smart-btn", {
                        staticClass: "fr",
                        class: { "w-100-pct": _vm.smAndDown },
                        attrs: {
                          label: "Manage Equipment List",
                          type: "primary",
                        },
                        on: { click: _vm.openManageEquipmentTypesPopup },
                      }),
                      _c("smart-btn", {
                        staticClass: "fr",
                        class: {
                          "w-100-pct mt-4": _vm.smAndDown,
                          "mr-4 export-csv": _vm.mdAndUp,
                        },
                        attrs: {
                          icon: _vm.ic_download,
                          label: "Export CSV",
                          "icon-class": "mr-2",
                          "icon-position": "left",
                          "icon-width": "18",
                          bg: "white",
                          border: "navy-blue",
                          font: "navy-blue",
                        },
                        on: { click: _vm.csvExport },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-row", { staticClass: "mt-8" }, [
                _c("label", { staticClass: "afs-clients" }, [
                  _vm._v(_vm._s(_vm.filteredEquipmentTypes.length)),
                ]),
                _c("label", { staticClass: "ml-1 account-lbl" }, [
                  _vm._v("equipment requests"),
                ]),
              ]),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "equipments-grid-wrapper pl-3 br-10" },
                        [_c("v-card-text", [_c("client-equipment-types")], 1)],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.pagingLength > 1
                ? _c(
                    "v-row",
                    { staticClass: "mt-6", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "auto" } },
                        [
                          _c("v-pagination", {
                            staticClass: "pl-3",
                            attrs: {
                              length: _vm.pagingLength,
                              "total-visible": "10",
                            },
                            on: { input: _vm.pageChange },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-snackbar",
                {
                  staticClass: "smart-snackbar",
                  scopedSlots: _vm._u([
                    {
                      key: "action",
                      fn: function (ref) {
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._b(
                              {
                                attrs: { color: "#007BFF", text: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.snackbar = false
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            [_vm._v(" Close ")]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.snackbar,
                    callback: function ($$v) {
                      _vm.snackbar = $$v
                    },
                    expression: "snackbar",
                  },
                },
                [
                  _c("img", {
                    staticClass: "success-icon",
                    attrs: { src: _vm.ic_green_success_checkmark },
                  }),
                  _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "navigation-details-eq",
          class: {
            active: _vm.displayManageEquipmentTypesPopup,
            "w-100-pct": _vm.smAndDown,
          },
        },
        [
          _c("manage-client-equipments", {
            on: {
              equipmentRemoved: _vm.equipmentRemoved,
              equipmentAdded: _vm.equipmentAdded,
              hide: function ($event) {
                _vm.displayManageEquipmentTypesPopup = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v("Loading Equipment Types"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }